import React, { Fragment } from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import CreateFolderForm from './CreateFolderForm';

export default function CreateFolderButton({
    id,
    propertyId,
    parentLoadData,
    selectedFolder,
    visible,
    toggleModal,
    folderName,
    setFolderName,
    status,
}) {
    const handleCreateFolderClick = () => {
        setFolderName('');
        toggleModal();
    };

    return (
        <Fragment>
            <Button
                color="primary"
                outline
                className="ml-2"
                size="xs"
                onClick={handleCreateFolderClick}
            >
                <FontAwesomeIcon icon={faPlus} />
                <span> </span>
                Create Folder
            </Button>

            {visible && (
                <CreateFolderForm
                    id={id}
                    toggleModal={toggleModal}
                    formLabel="Create Folder"
                    visible={visible}
                    propertyId={propertyId}
                    parentLoadData={parentLoadData}
                    status={status}
                    folderName={folderName}
                    setFolderName={setFolderName}
                    selectedFolder={selectedFolder}
                />
            )}
        </Fragment>
    );
}
